var React = require('react');

function Chevron (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15.1664 10.7093C15.6112 10.2928 15.6112 9.5943 15.1664 9.17784L8.5 3L1.83361 9.17784C1.3888 9.5943 1.3888 10.2928 1.83361 10.7093C2.24766 11.0969 2.89753 11.0969 3.31157 10.7093L8.5 5.9152L13.6884 10.7093C14.1025 11.0969 14.7523 11.0969 15.1664 10.7093Z","fill":"#E8EFFF"}));
}

Chevron.defaultProps = {"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none"};

module.exports = Chevron;

Chevron.default = Chevron;
